import { useState, useEffect, useCallback } from "react";
import { useAdminApi, toLocalDateStr, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

export default function CheckinReport() {
  const { API, AUTH } = useAdminApi();
  const today = toLocalDateStr(new Date());
  const [from, setFrom]       = useState(() => { const d = new Date(); d.setDate(d.getDate() - 13); return toLocalDateStr(d); });
  const [to, setTo]           = useState(today);
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch_ = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reports/checkin?from=${from}&to=${to}`, { headers: AUTH });
      const json = await res.json();
      setData(json);
    } catch { setData(null); }
    finally   { setLoading(false); }
  }, [from, to, API, AUTH]);

  useEffect(() => { fetch_(); }, [fetch_]);

  const doExport = () => {
    if (!data?.classes) return;
    const rows = data.classes.map(c => ({
      Date: c.date, Class: c.title, Teacher: c.teacher,
      Booked: c.booked, "Checked In": c.checkedIn, "No Show": c.noShow,
      "Check-in Rate %": c.checkinRate,
    }));
    rows.push({ Date: "TOTAL", Booked: data.totals.booked, "Checked In": data.totals.checkedIn,
      "No Show": data.totals.noShow, "Check-in Rate %": data.totals.checkinRate });
    exportXLSX("Check-in", rows, `florium-checkin-${from}-${to}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-filters">
        <div className="adm-filter-group">
          <label className="adm-filter-label">From</label>
          <input type="date" className="adm-input" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="adm-filter-group">
          <label className="adm-filter-label">To</label>
          <input type="date" className="adm-input" value={to} max={today} onChange={e => setTo(e.target.value)} />
        </div>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {data && !loading && (
        <>
          <div className="adm-report-summary-row">
            {[
              { label: "Classes",       value: data.classes.length },
              { label: "Total booked",  value: data.totals.booked },
              { label: "Checked in",    value: data.totals.checkedIn },
              { label: "No shows",      value: data.totals.noShow },
              { label: "Check-in rate", value: `${data.totals.checkinRate}%` },
            ].map(s => (
              <div key={s.label} className="adm-summary-chip">
                <span className="adm-summary-val">{s.value}</span>
                <span className="adm-summary-lbl">{s.label}</span>
              </div>
            ))}
          </div>
          <ExportBar onXLSX={doExport} />
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr><th>Date</th><th>Class</th><th>Teacher</th><th>Booked</th><th>Checked In</th><th>No Show</th><th>Rate</th></tr>
              </thead>
              <tbody>
                {data.classes.map((c, i) => (
                  <tr key={i}>
                    <td>{new Date(c.date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</td><td>{c.title}</td><td>{c.teacher}</td>
                    <td>{c.booked}</td>
                    <td><span className="adm-checkin-count">{c.checkedIn}</span></td>
                    <td className={c.noShow > 0 ? "adm-noshow" : ""}>{c.noShow}</td>
                    <td>
                      <div className="adm-rate-bar">
                        <div className="adm-rate-fill" style={{ width: `${c.checkinRate}%` }} />
                        <span>{c.checkinRate}%</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
